export enum RenderIndexMode{
    UNSIGNED_BYTE,
    UNSIGNED_SHORT,
    UNSIGNED_INT
}